export default "__VITE_ASSET__DRBAPwm5__"